import { defineNuxtRouteMiddleware } from 'nuxt/app'
import {useNavigationStore} from "~/stores/NavigationStore.js";
import {useAlternateHrefStore} from "~/stores/AlternateHrefStore.js";
import {useLocaleStore} from "~/stores/LocaleStore.js";

export default defineNuxtRouteMiddleware((to, from) => {
    const navigationStore = useNavigationStore();
    if (navigationStore.outdated) {
        return navigateTo(to.fullPath, { external: true });
    }
    navigationStore.cleanErrors();
    if (!useLocaleStore().isLanguageSwitchNavigation) {
        useAlternateHrefStore().clean();
    }

    if (to.name) {
        const routeName = to.name.split('_')[0];
        useLocaleStore().allowShipToCountryChange = !routeName.startsWith('checkout-');
    }
    if (!from.name) {
        return;
    }
    if (from.name.includes('register') || from.name.includes('login') || to.name.includes('checkout')) {
        return;
    }
    if (from.name) {
        navigationStore.incrementPageCount()
    }
})
